import Immutable, { Record, List } from 'immutable';

import OverallDevelopmentResultItem from './items';

const OverallDevelopmentResultRecord = Record({
  studentIDPId: undefined,
  studentId: undefined,
  items: new List(),
});

class OverallDevelopmentResult extends OverallDevelopmentResultRecord { }

const reviver = ([key, val]) => {
  if (! val) return [key, val];
  switch (key) {
    case 'studentIDPId':
      return [key, `${val}`];
    case 'studentId':
      return [key, `${val}`];
    case 'items':
      return [key, new List(val.map(OverallDevelopmentResultItem.create))];
    default:
      return [key, Immutable.fromJS(val)];
  }
};

OverallDevelopmentResult.create = (data) =>
  new OverallDevelopmentResult(data).mapEntries(reviver);

export default OverallDevelopmentResult;



// WEBPACK FOOTER //
// ./data/IndividualDevelopmentPlans/OverallDevelopment/result/model.js